export default __webpack_public_path__ + "static/media/news_card.12b3a7fb.png";